/**
 * ページ表示制御 — 白背景からコンテンツをふわっとフェードイン
 * - トップ: DOMContentLoaded + 200ms 後に開始
 * - 下層: load + フォント読み込み後に開始（トップに近い「待ってから」の体感）
 * 安全策: 3秒経過で強制表示
 */
(function () {
  var body = document.body;
  if (!body) return;

  var isHome = body.classList.contains('is-home');
  var SAFETY_MS = 3000;
  var HOME_FADE_DELAY_MS = 200;
  var revealed = false;

  function reveal() {
    if (revealed) return;
    revealed = true;
    body.classList.add('is-page-visible');
  }

  function startReveal() {
    requestAnimationFrame(reveal);
  }

  function whenFontsReady(callback) {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(callback).catch(callback);
      return;
    }

    callback();
  }

  function scheduleHomeReveal() {
    window.setTimeout(function () {
      startReveal();
    }, HOME_FADE_DELAY_MS);
  }

  function scheduleSubpageReveal() {
    function onReady() {
      whenFontsReady(startReveal);
    }

    if (document.readyState === 'complete') {
      onReady();
      return;
    }

    window.addEventListener('load', onReady, { once: true });
  }

  function scheduleReveal() {
    if (isHome) {
      scheduleHomeReveal();
      return;
    }

    scheduleSubpageReveal();
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    reveal();
    return;
  }

  window.setTimeout(reveal, SAFETY_MS);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReveal, { once: true });
  } else {
    scheduleReveal();
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;

    revealed = false;
    body.classList.remove('is-page-visible');

    requestAnimationFrame(function () {
      scheduleReveal();
    });
  });
})();
